export default "__VITE_ASSET__Dy62aVMh__"